import { render, staticRenderFns } from "./survey-details.vue?vue&type=template&id=f245ae86&scoped=true"
import script from "./survey-details.vue?vue&type=script&lang=js"
export * from "./survey-details.vue?vue&type=script&lang=js"
import style0 from "./survey-details.vue?vue&type=style&index=0&id=f245ae86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f245ae86",
  null
  
)

export default component.exports